<template>
    <div class="px-2">
        <v-card tile outlined class="custom_lessons-card">
            <v-toolbar flat>
                <v-toolbar-title><b>Lessons</b></v-toolbar-title>
                <v-spacer></v-spacer>
                <router-link
                    to="/admin/addlesson"
                    style="text-decoration: none"
                >
                    <v-btn color="secondary" type="submit"> Add Lesson </v-btn>
                </router-link>
            </v-toolbar>
            <v-form
                ref="tanpuraForm"
                @submit.prevent="saveTanpura"
                class="custom_form custom-bg_lessons"
            >
                <v-card>
                    <v-container>
                        <v-row no-gutters class="my-4">
                            <v-col cols="3" align="right" class="mr-3 mt-2">
                                <v-card-text class="pr-5">
                                    Tanpura (Background Music)
                                </v-card-text>
                            </v-col>
                            <v-col cols="3">
                                <v-badge
                                    right
                                    top
                                    avatar
                                    overlap
                                    color="blue"
                                    class="for_custom-badge"
                                >
                                    <template v-slot:badge>
                                        <v-avatar size="36" align="left">
                                            <v-file-input
                                                accept="audio/*"
                                                prepend-icon="mdi-pencil-outline"
                                                label="tanpuraAudio"
                                                ref="fileAudio"
                                                hide-input
                                                dense
                                                :rules="tanpuraAudioRules"
                                                :success="tanpuraAudioSuccess"
                                                @change="onAudioFileSelected"
                                                :disabled="disabledTanpura"
                                            >
                                                <!-- v-model="tanpura.tanpuraAudio" -->
                                            </v-file-input>
                                        </v-avatar>
                                    </template>
                                    <audio
                                        ref="audioElm"
                                        :src="tanpuraAud"
                                        controls
                                        max-height="50"
                                        min-height="50"
                                        max-width="150"
                                        min-width="150"
                                        contain
                                        elevation
                                        :disabled="disabledTanpura"
                                    ></audio>
                                </v-badge>
                            </v-col>
                            <v-col cols="1"></v-col>
                            <v-col cols="2">
                                <v-switch
                                    v-model="tanpura.tanpuraStatus"
                                    inset
                                    dense
                                    class="mt-2"
                                    color="blue"
                                    :label="
                                        tanpura.tanpuraStatus
                                            ? 'Active'
                                            : 'Inactive'
                                    "
                                >
                                    <!-- @change="changeTanpuraStatus()" -->
                                </v-switch>
                            </v-col>
                            <v-col cols="2">
                                <v-card-actions>
                                    <v-btn
                                        class="mx-5"
                                        :disabled="disabledTanpura"
                                        type="submit"
                                        color="secondary"
                                        width="90"
                                        @click="saveTanpura"
                                        >Save</v-btn
                                    >
                                </v-card-actions>
                            </v-col>
                        </v-row>
                        <v-row
                            v-if="errorMessageTanpura || successMessageTanpura"
                        >
                            <v-col cols="6" offset-md="2">
                                <v-alert
                                    v-if="errorMessageTanpura"
                                    type="error"
                                >
                                    {{ errorMessageTanpura }}
                                </v-alert>
                                <v-alert
                                    v-if="successMessageTanpura"
                                    type="success"
                                >
                                    {{ successMessageTanpura }}
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-form>
            <v-spacer></v-spacer>
            <br /><br />

            <div class="custom-bg_lessons">
                <v-row>
                    <v-spacer></v-spacer>
                    <v-card-actions>
                        <v-btn
                            class="mx-5 my-0"
                            type="submit"
                            color="secondary"
                            width="auto"
                            :disabled="disabledSaveSequence"
                            @click="saveNewSequence()"
                            >Save New Sequence</v-btn
                        >
                    </v-card-actions>
                </v-row>
                <v-row>
                    <v-spacer></v-spacer>
                    <div class="mr-3 my-3">Search:</div>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field
                            prepend="search"
                            type="text"
                            dense
                            v-model="search"
                            single-line
                            hide-details
                            outlined
                            no-gutters
                            height="5"
                            width="auto"
                            class="mx-5 my-0"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row
                            v-if="errorMessageChangeSequence || successMessageChangeSequence"
                        >
                            <v-col cols="6" offset-md="2">
                                <v-alert
                                    v-if="errorMessageChangeSequence"
                                    type="error"
                                >
                                    {{ errorMessageChangeSequence }}
                                </v-alert>
                                <v-alert
                                    v-if="successMessageChangeSequence"
                                    type="success"
                                >
                                    {{ successMessageChangeSequence }}
                                </v-alert>
                            </v-col>
                        </v-row>
                <!-- </v-row> -->

                <v-data-table
                    dense
                    fixed-header
                    :headers="headers"
                    bold
                    :items="lessons"
                    :items-per-page.sync="itemsPerPage"
                    :page.sync="pageNumber"
                    sort-by="['serialNum', 'lessonId', 'lessonTitle','lessonDescription','lessonStatus', 'isPaid']"
                    :search="search"
                >
                    <template v-slot:body="props">
                        <Draggable
                            :list="props.items"
                            tag="tbody"
                           @end="onDropCallback(props.items)"
                        >
                            <tr
                                v-for="(row, index) in props.items"
                                :key="index"
                            >
                                <td>
                                    {{
                                        (pageNumber - 1) * itemsPerPage +
                                        (index + 1)
                                    }}
                                </td>
                                <td>{{ row.lessonId }}</td>
                                <td>{{ row.lessonTitle }}</td>
                                <td>{{ row.lessonDescription }}</td>
                                <td>
                                    <v-switch
                                        v-model="row.lessonStatus"
                                        inset
                                        dense
                                        class="mt-2"
                                        color="blue"
                                        @change="
                                            saveLessonStatus(
                                                row._id,
                                                row.lessonStatus
                                            )
                                        "
                                        :label="
                                            row.lessonStatus
                                                ? 'Active'
                                                : 'Inactive'
                                        "
                                    >
                                    </v-switch>
                                </td>

                                <td>
                                    <v-switch
                                        v-model="row.isPaid"
                                        inset
                                        dense
                                        class="mt-2"
                                        color="blue"
                                        @change="
                                            saveLessionPaidStatus(
                                                row._id,
                                                row.isPaid
                                            )
                                        "
                                        :label="
                                            row.isPaid
                                                ? 'Paid'
                                                : 'Free'
                                        "
                                    >
                                    </v-switch>
                                </td>

                                <td>

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon
                                                class="mr-2"
                                                color="blue darken-3"
                                                v-on="on"
                                                @click="goToLessonInfoEdit(row)"
                                                >mdi-pencil
                                            </v-icon>
                                        </template>
                                        <span>View Details</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{}">
                                            <v-icon
                                                class="mr-2"
                                                color="blue darken-3"
                                                v-on:click="
                                                    deleteLesson(
                                                        row._id,
                                                    )
                                                "
                                                >mdi-delete
                                            </v-icon>
                                        </template>
                                        <span>Delete</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                        </Draggable>
                    </template>
                </v-data-table>
            </div>
        </v-card>
    </div>
</template>

<script>
import Lesson from "../../models/Lesson";
import Tanpura from "../../models/Tanpura";
import LessonQuestionMapping from "../../models/LessonQuestionMapping";
import CourseLessonMapping from "../../models/CourseLessonMapping";
import { mapMutations } from "vuex";
import url1 from "../../../config.js";
import Draggable from "vuedraggable";
export default {
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id) {
                    vm.$router.push("/");
                }
            }, 0);
        });
    },
    name: "Lessons",
    components: { Draggable },

    data() {
        return {
            search: "",
            url: url1.url,
            disabled: false,
            disabledTanpura: false,
            file: "",

            headers: [
                { text: "S.No", value: "serialNum" },
                { text: "Lesson Id", value: "lessonId" },
                { text: "Title", value: "lessonTitle" },
                { text: "Description", value: "lessonDescription" },
                { text: "Status", value: "lessonStatus" },
                { text: "Paid", value: "isPaid" },
                { text: "", value: "delete_viewDetail" },
            ],
            itemsPerPage: 10,
            pageNumber: 1,
            modifiedLessonsSubArraySequence:[],
            sequenceChanged: false,
            disabledSaveSequence:false,

            lessons: [],
            lesson: new Lesson(),
            tanpura: new Tanpura(),
            tanpuraAud: "",

            errorMessage: "",
            errorMessageTanpura: "",
            successMessageTanpura: "",
            successMessageChangeSequence:"",
            errorMessageChangeSequence:"",

            tanpuraAudioSuccess: false,
            tanpuraAudioRules: [
                //         v =>
                //         (!v || v.size<1000000) ||"Tanpura audio size should be less than 1MB",
            ],
        };
    },

    methods: {
        ...mapMutations(["setLesson"]),

        getLessons() {
            Lesson.getLessons(this.auth.token)
                .then((res) => {
                    this.lessons = res.data;
                })
                .catch((err) => {
                    console.error(err.response.data);
                });
        },

        getTanpura() {
            //console.log('get tanpura 0')
            Tanpura.get(this.auth.token)
                .then((res) => {
                    //console.log('get tanpura');
                    this.tanpura = res.data;
                    //console.log('tanpura audio', res.data.tanpuraAudio);
                    this.tanpuraAud =
                        this.url + "/uploads/" + res.data.tanpuraAudio;
                })
                .catch((err) => console.error(err.response.data));
        },

        onAudioFileSelected() {
            if (event.target.files[0]) {
                this.file = event.target.files[0];
                var reader = new FileReader();
                var vm = this;
                reader.onload = (e) => {
                    vm.tanpuraAud = e.target.result;
                };
                reader.readAsDataURL(this.file);
                this.tanpura.tanpuraAudio = this.file;
                //console.log('this.on audio file selected', this.tanpura.tanpuraAudio, 'event.targetfiles', event.target.files[0]);
            }
        },

        saveTanpura() {
            this.disabledTanpura = true;
            //console.log('inside save tanpura');
            //console.log('tanpura aud 1', this.tanpuraAud);
            const formData = new FormData();
            formData.append("tanpuraAudio", this.tanpura.tanpuraAudio);
            formData.append("tanpuraStatus", this.tanpura.tanpuraStatus);
            Tanpura.putTanpura(this.tanpura._id, formData, this.auth.token)
                .then((res) => {
                    // console.log('res', res.data);
                    this.tanpura = res.data;
                    this.tanpuraAud =
                        this.url + "/uploads/" + this.tanpura.tanpuraAudio;
                    //console.log('tanpura aud 2', this.tanpuraAud);
                    this.disabledTanpura = false;
                    this.successMessageTanpura = "Tanpura saved successfully";
                    setTimeout(() => (this.successMessageTanpura = ""), 5000);
                })
                .catch((err) => {
                    //console.error(err.response.data);
                    //console.log('tanpura aud 3', this.tanpuraAud);
                    this.errorMessageTanpura = err.response.data;
                    setTimeout(() => (this.errorMessageTanpura = ""), 5000);
                });
        },
        

        saveLessonStatus(lesson_id, status) {
            //console.log('lesson status', status);
            CourseLessonMapping.putLessonStatusByLessonMaster(
                lesson_id,
                status,
                this.auth.token
            )
                .then((res) => {
                    console.log("res", res.data);
                })
                .catch((err) => console.error(err.response.data));
        },

        saveLessionPaidStatus(lesson_id, status) {
            //console.log('lesson status', status);
            Lesson.putLessionPaidStatus(
                lesson_id,
                status,
                this.auth.token
            )
                .then((res) => {
                    console.log("res", res.data);
                })
                .catch((err) => console.error(err.response.data));
        },


        deleteLesson(lesson_id) {//, index
        let pageNumberTemp=this.pageNumber;
        let itemsPerPageTemp=this.itemsPerPage;
            LessonQuestionMapping.deleteLesson(lesson_id, this.auth.token)
                .then((res) => {
                    //console.log('index', index);
                    console.log("lessons res.data delete", res.data);
                    this.lessons=res.data.collection;
                    alert('Lesson deleted successfuly');
                    //this.lessons.splice(index, 1);
                    
                    this.pageNumber=pageNumberTemp;
                    this.itemsPerPage=itemsPerPageTemp;
                })
                .catch((err) => {
                    alert('Error occurred while deleting lesson');
                    console.error(err.response.data)
                    });
        },
        onDropCallback(newlySequencedItems) {
            this.sequenceChanged = true;
            console.log("move", newlySequencedItems);
            this.modifiedLessonsSubArraySequence=newlySequencedItems;
        },
        saveNewSequence() {
            //alert("Sequence changed successfully");
            this.disabledSaveSequence = true;
            if (!this.sequenceChanged) {
                alert("There is no change in sequence");
                this.disabledSaveSequence = false;
                return;
            }

            Lesson.saveLessonsNewSequence(
                this.itemsPerPage,
                this.pageNumber,
                this.modifiedLessonsSubArraySequence,
                this.auth.token
            )
                .then((res) => {
                    this.lessons = res.data;
                    //alert("Sequence changed successfully");
                    this.successMessageChangeSequence = "Sequence changed successfully";
                    setTimeout(() => (this.successMessageChangeSequence = ""), 5000);
                    this.disabledSaveSequence = false;
                    this.sequenceChanged = false;
                    this.modifiedLessonsSubArraySequence=[];
                })
                .catch((err) => {
                    //alert("Sequence could not be changed");
                    this.errorMessageChangeSequence = "Sequence could not be changed";
                    setTimeout(() => (this.errorMessageChangeSequence = ""), 5000);
                    console.error(err.response.data);
                    this.modifiedLessonsSubArraySequence=[]
                });
        },

        // changeTanpuraStatus(){
        //     if(this.tanpura.tanpuraStatus===false)
        //         this.disabled=true;
        //     else
        //         this.disabled=false;
        //     Tanpura.changeStatus(this.tanpura.tanpuraStatus)
        // }
        goToLessonInfoEdit(lessonItem) {
            //console.log("go to lesson info edit");
            this.setLesson(lessonItem);
            this.$router.replace("/admin/lessoninfoedit");
        },
    },

    computed: {
        auth() {
            return this.$store.state.auth;
        },
    },

    mounted() {
        this.getLessons();
        this.getTanpura();
    },
};
</script>

<style scoped>
.theme--light.v-card {
    background: transparent;
    border: 0;
}
.custom_lessons-card >>> header {
    background: transparent !important;
}
.custom_lessons-card >>> header .v-toolbar__content {
    padding: 0;
}
.custom-bg_lessons {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-top: 3px solid #d2d6de;
}
.custom_lessons-card >>> .v-data-table-header__icon {
    margin-left: 10px;
}
.custom_lessons-card >>> .v-data-table-header > tr > th {
    font-size: 14px;
    padding: 0 4px;
}
.custom_lessons-card >>> .v-data-footer {
    margin: 0;
    font-size: 14px;
}
.custom_lessons-card >>> .v-input__slot {
    min-height: 32px !important;
}
.custom_lessons-card >>> table {
    border-radius: 0;
    border-collapse: collapse;
    border: 0 !important;
}
.custom_lessons-card >>> table tr td,
.custom_lessons-card >>> table tr th {
    border: 1px solid rgba(0, 0, 0, 0.12) !important;
    box-shadow: none !important;
}
.custom_lessons-card
    >>> .v-data-table__wrapper
    table
    tbody
    > tr
    > td:last-child,
.custom_lessons-card
    >>> .v-data-table__wrapper
    table
    thead
    > tr
    > th:last-child {
    text-align: center !important;
}
.custom_lessons-card >>> .v-data-footer {
    border: 0;
}
@media only screen and (max-width: 992px) {
    .custom_lessons-card >>> .v-data-table-header > tr > th {
        font-size: 12px;
    }
    .custom_lessons-card >>> .v-data-table-header > tr > th:first-child {
        min-width: 65px;
    }
    .custom_lessons-card >>> .v-data-table-header > tr > th:nth-child(2),
    .custom_lessons-card >>> .v-data-table-header > tr > th:nth-child(3) {
        min-width: 105px;
    }
}

.custom_form >>> .v-badge__badge.blue {
    height: 30px;
    min-width: 30px;
    border-radius: 50px;
}

.custom_form >>> .mdi-pencil-outline::before {
    font-size: 18px;
}
</style>
